module.exports = __webpack_public_path__ + "static/circle-produce-8a3c9fd5355580b08481f3bf49c3ad37.png";